'use client';

import { useEffect } from 'react';
import { deferIfPrerendering } from '@/utils/deferIfPrerendering';

export interface SalesforcePznProps {
    campaignId: string;
}

function readCookie(name: string): string {
    const entry = document.cookie.split(';').find((c) => c.trim().startsWith(`${name}=`));
    return entry ? entry.split('=')[1].trim() : '';
}

function parseUserInfoCookie(): Record<string, string> | null {
    const raw = readCookie('sxm_user_info');
    if (!raw) return null;
    try {
        return JSON.parse(decodeURIComponent(raw));
    } catch {
        return null;
    }
}

export default function SalesforcePzn({ campaignId }: SalesforcePznProps): React.JSX.Element {
    useEffect(() => {
        const fire = () => {
            const accountId = new URLSearchParams(window.location.search).get('accountID') ?? '';
            if (!accountId) return;

            const userInfo = parseUserInfoCookie();
            if (!userInfo) return;

            (window as BrowserWindow).pushToAdobe({
                event: 'sfcampaign-dotcom-analytics-serverside-query',
                salesForceInfoServerSide: {
                    [campaignId]: {
                        statType: 'Query',
                        campaignId: userInfo.cmp_id,
                        campaignName: userInfo.cmp_name,
                        experienceId: userInfo.exp_id,
                        experienceName: userInfo.exp_name,
                        userGroup: userInfo.usr_grp,
                        sfPZNSegment: userInfo.sf_seg,
                    },
                },
            });
        };

        // defer until activation - firing Adobe events during prerender inflates query counts
        deferIfPrerendering(fire);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <></>;
}
